import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Plus } from 'lucide-react';
import { useIntl } from 'react-intl';

import {
  apiPostStoryQuestionsCategoryById,
  APIPostStoryQuestionsCategoryPayload,
  StoryQuestionsCategory,
} from '@/shared/api';
import { storyByIdQueryOptions } from '@/shared/queries';
import { Button } from '@/shared/ui/button';

type AddNewStorySectionButtonProps = {
  storyId: string;
};

export const AddNewStorySectionButton = ({ storyId }: AddNewStorySectionButtonProps) => {
  const intl = useIntl();
  const queryClient = useQueryClient();

  const mutation = useMutation<
    StoryQuestionsCategory,
    Error,
    APIPostStoryQuestionsCategoryPayload
  >({
    mutationFn: (payload) => {
      return apiPostStoryQuestionsCategoryById(payload).then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: storyByIdQueryOptions(storyId).queryKey,
      });
    },
  });

  return (
    <Button
      variant="outline"
      onClick={() => mutation.mutate({ storyId: String(storyId) })}
      size="lg"
      className="w-full"
    >
      <Plus /> {intl.formatMessage({ id: 'button.addNewSection' })}
    </Button>
  );
};
